import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';


@Injectable()
export class ValoresReceberService {

    constructor(private http: HttpClient) { }

    getValores(){
    return this.http.get<any>('assets/demo/valoresrecebidos.json')
        .toPromise()
        .then(res => res.data as any[])
        .then(data => data);
    }
}